export {FaqComponent} from './faq.component';
